import React, { useState, useRef, useEffect } from "react";
import { FaTrashAlt, FaEdit } from "react-icons/fa";
import useToast from "../../../API/GlobalHooks/useToast";
import { useModal } from "../../ConfirmationModal/ModalContext";
import { handleDelete_data, handleGet_data, handleSubmitUpdate_data, handleSubmit_data } from "./bannerModel";
import { getImageUrl } from "../../../MIS/Global";


export default function BannerUploadPage() {
  const showToast = useToast();
  const { showModal } = useModal();
  const [banners, setBanners] = useState([]);
  const [listLoading, setListLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  const [actionLoader, setActionLoader] = useState({});
  const [preview, setPreview] = useState(null);
  const [files, setFiles] = useState(null);
  const [link, setLink] = useState("");
  const [modalImage, setModalImage] = useState(null);
  const [editIndex, setEditIndex] = useState(null);
  const [editLink, setEditLink] = useState("");
  const [id, setId] = useState(0);

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setPreview(URL.createObjectURL(file));
      setFiles(file)
    }
  };

  useEffect(() => {
    handleGet_data({setListLoading,setBanners,setFiles})
  },[])
  

  const handleSave = () => {
    if (!preview){return alert("Please add image and link");}
    let data={imgpath:files,redirect_path:link}
    handleSubmit_data({data,setLoading,showToast,setListLoading,setBanners,setFiles,setPreview,setLink})    
    setPreview(null);
    setLink("");
  };

 
  const openImageModal = (image) => {
    setModalImage(getImageUrl(`${image}`));
  };

  const closeImageModal = () => {
    setModalImage(null);
  };

  const openEditModal = (index,id=0) => {
    setEditIndex(index);
    setEditLink(banners[index].redirect_path);
    setId(id);
  };

  const handleEditSave = () => {    
    let data={redirect_path:editLink,id:id}
    handleSubmitUpdate_data({data,setLoading,showToast,setListLoading,setBanners,setFiles,setPreview,setLink})    
    setEditIndex(null);
    setEditLink("");
    setId(0);
  };

  return (
    <div className="container py-5">
      <h2 className="mb-4 text-center fw-bold">🎯 Banner Upload & Redirect Link</h2>

      <div className="row g-4">
        {/* Upload Section */}
        <div className="col-md-5">
          <div className="card shadow-sm p-4 h-100">
            <h5 className="mb-3">Upload Banner Image</h5>
            <input
              type="file"
              accept="image/*"
              className="form-control form-control-sm mb-3"
              onChange={handleImageChange}
            />
            <textarea              
              placeholder="Enter redirect link (https://...)"
              className="form-control form-control-sm mb-3"
              value={link}
              onChange={(e) => {
                setLink(e.target.value);                
              }}              
            />
            {preview && (
              <div className="mb-3 text-center">
                <img
                  src={preview}
                  alt="Preview"
                  className="img-thumbnail"
                  style={{ maxHeight: "180px", objectFit: "contain" }}
                />
              </div>
            )}
            <button type="button" className="btn btn-primary w-100" onClick={handleSave} disabled={loading}>
              {loading ? (
                <>
                  <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                  Saving...
                </>
              ) : (
                "Save"
              )}
            </button>
          </div>
        </div>

        {/* Saved Banners Section */}
        <div className="col-md-7">
          <h5 className="mb-3">📂 Saved Banners</h5>
          {banners.length === 0 ? (
            <p className="text-muted">No banners saved yet.</p>
          ) : (
            <div className="row g-3">
              {banners.map((item, index) => (
                <div key={index} className="col-sm-6">
                  <div className="card banner-card h-100 shadow-sm position-relative">
                    {/* Image */}
                    <img
                      src={getImageUrl(`${item.imgpath}`)}
                      alt={`Banner ${index}`}
                      className="card-img-top banner-img"
                      onClick={() => openImageModal(item.imgpath)}
                    />

                    <div className="card-body p-2">
                      <div className="d-flex justify-content-between gap-2">
                        <button
                          className="btn btn-sm btn-outline-secondary w-50"
                          onClick={() => openEditModal(index,item?.id)}
                        >
                          <FaEdit className="me-1" />
                          Edit
                        </button>
                        <button
                          type="button"
                          className="btn btn-sm btn-outline-danger w-50"
                          onClick={() =>{
                            showModal({
                              title: "Confirm Deletion",
                              message: "Are you sure you want to delete?",
                              onConfirm: () => {
                                handleDelete_data({
                                  item,showToast,setBanners,setActionLoader
                                })
                              },
                              confirmText: "Yes",
                              cancelText: "No",
                            });                            
                          }}
                        >
                            {actionLoader?.deleteId === item.id ? (
                                <span
                                  className="spinner-border spinner-border-sm"
                                  role="status"
                                  aria-hidden="true"
                                />
                              ) : (<>
                                <FaTrashAlt className="me-1" />
                                Delete
                                </>
                          )}                          
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>

      {/* Modal for Full Image */}
      {modalImage && (
        <div
          className="modal d-block"
          tabIndex="-1"
          onClick={closeImageModal}
          style={{ background: "rgba(0,0,0,0.7)" }}
        >
          <div
            className="modal-dialog modal-dialog-centered modal-lg"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="modal-content">
              <div className="modal-body p-0">
                <img
                  src={modalImage}
                  alt="Large View"
                  className="w-100"
                  style={{ objectFit: "contain", maxHeight: "80vh" }}
                />
              </div>
              <div className="modal-footer">
                <button className="btn btn-secondary" onClick={closeImageModal}>
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Modal for Editing Link */}
      {editIndex !== null && (
        <div
          className="modal d-block"
          tabIndex="-1"
          style={{ background: "rgba(0,0,0,0.7)" }}
          onClick={() => setEditIndex(null)}
        >
          <div
            className="modal-dialog modal-dialog-centered"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Update Link</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setEditIndex(null)}
                ></button>
              </div>
              <div className="modal-body">
                <textarea                  
                  className="form-control"
                  value={editLink}
                  rows={5}
                  onChange={(e) => {
                    setEditLink(e.target.value);               
                  }}               
                />
              </div>
              <div className="modal-footer">
                <button
                  className="btn btn-secondary"
                  onClick={() => setEditIndex(null)}
                >
                  Cancel
                </button>
                <button className="btn btn-primary" 
                  onClick={handleEditSave}>
                  Update
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* CSS Styling */}
      <style jsx>{`
        .banner-card {
          border-radius: 1rem;
          overflow: hidden;
          position: relative;
        }

        .banner-img {
          height: 120px;
          object-fit: contain;
          cursor: pointer;
          background-color: #f8f9fa;
        }

        @media (max-width: 768px) {
          .banner-img {
            height: 100px;
          }
        }
      `}</style>
    </div>
  );
}
